export default "__VITE_ASSET__DG9ZAX2s__"